export default "__VITE_ASSET__CxCkudF1__"